<template>
  <div>
    <div>
      <div class="k8m-pods-details-info-container">
        <RexInfoLabel
          class="k8m-pods-details-icon-label"
          :isError="false"
          :info="routeTextValue"
        />
        <span
          class="k8m-pods-details-status-icon"
          :class="
            isActive === 'true'
              ? 'k8m-pods-details-active-icon'
              : isActive === 'unknown'
                ? 'k8m-pods-details-unknown-icon'
                : 'k8m-pods-details-inactive-icon'
          "
          v-tooltip:top="{
            content:
              isActive === 'true'
                ? this.$t('k8.ready')
                : isActive === 'unknown'
                  ? this.$t('k8.unknown')
                  : this.$t('k8.notReady'),
          }"
        ></span>
      </div>
    </div>
    <div class="k8m-pods-details-tags-container">
      <div
        class="k8m-pods-details-tags-item"
        v-for="(item, index) in currentTags"
        :key="'tags' + index"
      >
        <K8MTags :label="item.label" :value="item.value" />
      </div>
    </div>
    <div class="k8m-pods-details-metrics-wrapper">
      <div class="k8m-pods-details-metrics-Container">
        <div
          v-for="data in metricsCardsData"
          :key="data.key"
          class="k8m-pods-details-stats-container"
          @click="openModal(data)"
        >
          <InfoStats
            :className="data.className"
            :class="
              data.textTitle === 'Status' &&
              data.textValue === 'Terminated' &&
              'k8m-pods-details-cursor-content'
            "
            :textTitle="data.textTitle"
            :textValColor="data.textValColor"
            :textValue="data.textValue"
          >
            <template #actions>
              <div
                v-if="
                  data.textTitle === 'Status' && data.textValue === 'Terminated'
                "
              >
                <BaseIcon
                  name="outlineRightArrow"
                  width="1.2rem"
                  height="1.2rem"
                />
              </div>
            </template>
          </InfoStats>
        </div>
      </div>
    </div>
    <div class="k8m-pods-details-wrapper">
      <div
        class="k8m-pods-details-chart-element"
        v-for="(chartConfig, index) in chartConfigs"
        :key="'line' + index"
        :style="{ width: chartConfig.width }"
      >
        <GraphBuilder
          :chartConfig="chartConfig"
          :index="index"
          :layoutIndex="0"
        />
      </div>
    </div>
    <DetailsModal
      v-if="showDetails"
      @onClose="() => (showDetails = false)"
      :initValues="initValues"
    />
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex';
import K8MTags from '@/components/K8M/Common/K8MTags.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import InfoStats from '@/rex-components/rex-info-stats.vue';
import GraphBuilder from '@/components/Common/GraphBuilder.vue';
import DetailsModal from '@/components/K8M/Pod/K8MPodDetailsModal.vue';
import { k8mPodDetailsGraphs } from '@/components/K8M/Pod/pod.graph.config';
import {
  K8PodTags,
  K8PodsMetrics,
  K8Routes,
  K8BreadcrumbNames,
  K8MutationType,
  K8StatusMetrics,
  NodeSatus,
  PodScheduleStatus,
  PodTerminatedStatus,
  TagsColorMapping,
  CustomClassType,
} from '../k8.types';
import { k8Scopes } from '@/store/modules/k8/k8-types';
import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants';

export default {
  name: 'K8MPodDetails',
  components: {
    K8MTags,
    RexInfoLabel,
    InfoStats,
    GraphBuilder,
    DetailsModal,
  },
  data() {
    return {
      routeTextValue: '',
      currentTags: K8PodTags,
      metricsCardsData: K8PodsMetrics,
      showDetails: false,
      isActive: 'false',
      metricResponse: [],
      terminatedDetails: {},
    };
  },
  methods: {
    ...mapMutations('k8State/k8CommonState', ['setCurrentRouteConfig']),
    ...mapActions('k8State/k8CommonState', {
      getK8CardsDataAction: 'GET_K8_CARDS_PROPERTIES',
      getK8TagsData: 'GET_K8_ATTRIBUTES',
    }),
    getSelectedEntity() {
      this.routeTextValue = this.currentPod.label;
      return this.currentPod.label;
    },
    getWorkloadBread() {
      return this[K8MutationType[this.getCurrentK8Tab]].label;
    },
    openModal(data) {
      if (data.textTitle !== 'Status' || data.textValue !== 'Terminated') {
        return;
      }
      this.showDetails = true;
    },
    getMetricbyNameOfCards() {
      return this.metricsCardsData.map((item) => item.metricName);
    },
    async fetchTerminatedPodDetails() {
      const params = {
        request: {
          metricNames: ['k8s_pods_v2_last_terminated_exitcode'],
          entity: {
            scope: k8Scopes.SERVICE_INSTANCE,
            serviceName: this.getCurrentK8Cluster?.key,
            serviceInstanceName: this.currentPod.key,
            normal: true,
          },
        },
        duration: this.getDurationTime,
        valueColumn: 'value',
      };
      const metricData = await this.getK8CardsDataAction(params);
      this.terminatedDetails = {
        title: this.$t('k8.terminatedPodDetails'),
        reason: this.$t('k8.lastTerminatedReason'),
        exitCode: this.$t('k8.exitCode'),
        message: this.$t('k8.message'),
        code: metricData[0]?.value,
        messageDetails: this.getStatusMessage(metricData[0]?.value),
      };
    },
    async fetchCardsProperties() {
      try {
        this.metricResponse = [];
        let metricNames = this.getMetricbyNameOfCards();
        const params = {
          request: {
            metricNames: metricNames,
            entity: {
              scope: k8Scopes.SERVICE_INSTANCE,
              serviceName: this.getCurrentK8Cluster?.key,
              serviceInstanceName: this.currentPod.key,
              normal: true,
            },
          },
          duration: this.getDurationTime,
          valueColumn: 'value',
        };
        const metricData = await this.getK8CardsDataAction(params);
        if (Array.isArray(metricData) && metricData.length > 0) {
          this.metricResponse = metricData;
          this.populateInfoCardData();
        }
      } catch (error) {
        console.log(error);
        this.metricResponse = [];
      }
    },
    populateInfoCardData() {
      this.metricsCardsData.map((item) => {
        let value =
          this.metricResponse
            .find((resp) => resp.name === item.metricName)
            ?.value?.toString() ?? item?.textValue;
        item.textValue = this.getCardValue(
          item.textTitle,
          value.split(',')[0].toLowerCase(),
        );
        item.textValColor = item?.type
          ? this.getTextValColor(item)
          : item.textValColor;
      });
    },
    getTextValColor(item) {
      return TagsColorMapping.ACTIVE_LIST.includes(item.textValue)
        ? CustomClassType.GOOD
        : TagsColorMapping.INACTIVE_LIST.includes(item.textValue)
          ? CustomClassType.POOR
          : CustomClassType.TANGERINE;
    },
    getCardValue(text, value) {
      switch (text) {
        case 'IsReady':
          return NodeSatus[value];
        case 'IsScheduled':
          return PodScheduleStatus[value];
        case 'Status':
          return this.getTerminatedStatus(value);
        default:
          return value;
      }
    },
    getTerminatedStatus(value) {
      const status = this.metricsCardsData.find(
        (item) => item.metricName === 'k8s_pods_v2_status_ready',
      );
      return status.textValue === 'Unknown'
        ? this.$t('k8.unknown')
        : PodTerminatedStatus[value];
    },
    populateTagsData(tagsData) {
      this.currentTags.map((item) => {
        let value = tagsData[item.meta] ? tagsData[item.meta] : item.value;
        item.value = item.meta.includes('metaProperty')
          ? value
          : this[item.meta].label;
      });
    },
    async fetchTagsData() {
      try {
        const params = {
          entityId: this[K8MutationType[this.getCurrentK8Tab]].key,
        };
        const tagsValue = await this.getK8TagsData(params);
        if (tagsValue) {
          this.populateTagsData(tagsValue);
        } else {
          this.resetTagsData();
        }
      } catch (error) {
        console.log(error);
      }
    },
    resetTagsData() {
      this.currentTags.map((item) => {
        item.value = '';
      });
    },
    async getStatus() {
      const params = {
        request: {
          metricNames: [K8StatusMetrics.pods],
          entity: {
            scope: k8Scopes.SERVICE_INSTANCE,
            serviceName: this.getCurrentK8Cluster?.key,
            serviceInstanceName: this.currentPod.key,
            normal: true,
          },
        },
        duration: this.getDurationTime,
        valueColumn: 'value',
      };
      const metricData = await this.getK8CardsDataAction(params);
      this.isActive = metricData[0]?.value.split(',')[0].toLowerCase();
    },
    getStatusMessage(status) {
      let message = '';
      switch (status) {
        case '0':
          message = this.$t('k8.ec0');
          break;
        case '1':
          message = this.$t('k8.ec1');
          break;
        case '125':
          message = this.$t('k8.ec125');
          break;
        case '126':
          message = this.$t('k8.ec126');
          break;
        case '127':
          message = this.$t('k8.ec127');
          break;
        case '128':
          message = this.$t('k8.ec128');
          break;
        case '134':
          message = this.$t('k8.ec134');
          break;
        case '137':
          message = this.$t('k8.ec137');
          break;
        case '139':
          message = this.$t('k8.ec139');
          break;
        case '143':
          message = this.$t('k8.ec143');
          break;
        case '255':
          message = this.$t('k8.ec255');
          break;
        default:
          message = this.$t('k8.unknownError');
          break;
      }
      return message;
    },
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapGetters('k8State/k8CommonState', [
      'getCurrentK8Tab',
      'getCurrentK8Cluster',
    ]),
    ...mapState('k8State/k8CommonState', [
      'currentPod',
      'currentDep',
      'currentStatefulset',
      'currentDaemonset',
      'currentCluster',
    ]),
    initValues() {
      return this.terminatedDetails;
    },
    chartConfigs() {
      return k8mPodDetailsGraphs().lineCharts;
    },
  },
  mounted() {
    if (this.getCurrentK8Tab === K8_NAVTABS.K8M_POD_TAB) {
      this.setCurrentRouteConfig([
        {
          name: 'k8mCluster',
          path: 'clusterOverview',
          breadcrumbName: 'Cluster',
          tab: K8_NAVTABS.K8M_CLUSTER_TAB,
        },
        {
          name: K8Routes[this.getCurrentK8Tab],
          path: '/' + this.getCurrentK8Tab,
          breadcrumbName: K8BreadcrumbNames[this.getCurrentK8Tab],
          tab: this.getCurrentK8Tab,
        },
        {
          name: 'k8mPodDetails',
          path: '/podDetails',
          breadcrumbName: this.getSelectedEntity(),
          tab: K8_NAVTABS.K8M_POD_TAB,
        },
      ]);
    } else {
      this.setCurrentRouteConfig([
        {
          name: 'k8mCluster',
          path: 'clusterOverview',
          breadcrumbName: 'Cluster',
          tab: K8_NAVTABS.K8M_CLUSTER_TAB,
        },
        {
          name: K8Routes[this.getCurrentK8Tab],
          path: '/' + this.getCurrentK8Tab,
          breadcrumbName: K8BreadcrumbNames[this.getCurrentK8Tab],
          tab: this.getCurrentK8Tab,
        },
        {
          name: 'k8mDetails',
          path: '/details',
          tab: this.getCurrentK8Tab,
          breadcrumbName: this.getWorkloadBread(),
        },
        {
          name: 'k8mPodDetails',
          path: '/podDetails',
          tab: K8_NAVTABS.K8M_POD_TAB,
          breadcrumbName: this.getSelectedEntity(),
        },
      ]);
    }
    this.fetchCardsProperties();
    this.getStatus();
    this.fetchTerminatedPodDetails();
    this.fetchTagsData();
  },
  watch: {
    getDurationTime() {
      this.fetchCardsProperties();
      this.getStatus();
      this.fetchTerminatedPodDetails();
      this.fetchTagsData();
    },
  },
};
</script>
<style scoped lang="scss">
.k8m-pods-details-icon-label {
  color: $font-primary;
  font-size: 1.4em;
  font-weight: bold;
  display: flex;
  padding-right: 0.6rem;
}
.k8m-pods-details-tags-container {
  display: flex;
  margin-top: 1rem;
  margin-right: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $border-gray;
  flex-wrap: wrap;
}
.k8m-pods-details-tags-item {
  padding-right: 1rem;
  padding-bottom: 1rem;
}
.k8m-pods-details-metrics-wrapper {
  display: flex;
  flex-flow: row wrap;
  margin-top: 1.23rem;
  align-items: center;
}
.k8m-pods-details-metrics-Container {
  margin: -0.4rem;
  display: grid;
  width: 100%;
  grid-template-columns: 25% 25% 25% 25%;
}
.k8m-pods-details-stats-container {
  display: flex;
}
.info-cards {
  margin: 0.397rem;
  border-radius: 0.4rem;
  padding-left: 2.188rem;
  padding-bottom: 2rem;
  padding-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.k8m-pods-details-info-container {
  display: flex;
  align-items: baseline;
}
.k8m-pods-details-status-icon {
  width: 0.8rem;
  height: 0.8rem;
  border: 0.1rem solid $color-white;
  border-radius: 50%;
}
:deep(.textVal) {
  font-size: 2.5rem;
}

:deep(.textTitle) {
  font-size: 1rem;
}

.k8m-pods-details-chart-element {
  width: 100%;
  margin-bottom: 1.5em;
  margin-top: 4em;
  margin-left: 0.125em;
}
.k8m-pods-details-wrapper {
  flex-flow: row wrap;
  display: flex;
  position: relative;
  margin-top: 1.438em;
  justify-content: space-between;
  margin-right: 1rem;
}
.k8m-pods-details-cursor-content {
  cursor: pointer;
}
.k8m-pods-details-inactive-icon {
  background-color: $color-dark-red;
}
.k8m-pods-details-active-icon {
  background-color: $color-green;
}
.k8m-pods-details-unknown-icon {
  background-color: $color-brand-accent;
}
</style>
